// finds all elements with class="count" and initializes the jquery.count-to.js plugin on those elements when user scrolling has brought them into view. data-from and data-to are required. Ex: <span class="count" data-from="0" data-to="612">612</span> With no additional classes, the number format does not include commas for numbers greater than 999. If you want a comma (ex: 1,234) the class should be class="count comma-format". When the counting is complete, a class of "counted" is added to the element.

$(document).ready(function(){

	// only initialize on non-touch devices (aka desktop computers with scroll wheels)
	if ($('html').hasClass('no-touch')) {

		var windowH = $(window).height();
		var counters = $('.count');

		counters.each(function(){
			var cur = $(this);
		
			cur.text(cur.data('from'));
		
			checkCounter(cur);
		});

		$(window).scroll(function() {
			clearTimeout($.data(this, 'scrollCountTimer'));
			$.data(this, 'scrollCountTimer', setTimeout(function() {
				counters.each(function(){
					checkCounter($(this));
				});
			}, 50));
		});
	}
	
	function checkCounter(el) {
		var scrollTop = $(window).scrollTop();
	
		if (el.hasClass('counted') == false && scrollTop + windowH > el.offset().top) {
				
			var format = undefined;
		
			if (el.hasClass('comma-format')) {
				format = function (value, options) {
					return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
				}
			}
				
			el.countTo({
				speed: 1000,
				formatter: format
			});
			el.addClass('counted');
		}
	}
});